export const config = {
    infinite: true,
    placeFocusBack: false,
};
